import {pluck, inject} from 'vitrarius'

export const servicesLens = data => inject('services', data)
export const latestLens = data => inject('latest', data)
export const allLens = data => inject('all', data)
export const movementLens = pluck('movement')
export const clippingLens = pluck('clipping')
export const blockedTenantLens = pluck('blockedTenants')